import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from '../../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
import List from './List/View'
import ListPegawai from './ListPegawai/View'
import IndexPegawai from './IndexPegawai/View'
import Create from './Create/View'
import Detail from './Detail/View'
import Update from './Update/View'
import Approve from './Approve/View'
import ApproveBawahan from './ApproveBawahan/View'
import Revoke from './Revoke/View'
import ListBawahan from './ListBawahan/View'
import Saldo from './Saldo/View'

const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _create = queryParams.get('create')
    const _revoke = queryParams.get('revoke')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _print = queryParams.get('print')
    const _listBawahan = queryParams.get('list_bawahan')
    const _approveBawahan = queryParams.get('approve_bawahan')
    const _saldo = queryParams.get('saldo')
    const _listPegawai = queryParams.get('list_pegawai')
    const _detailPegawai = queryParams.get('detail_pegawai')

    if (_create != null) {
    	return accessRole('create') ? <Create /> : <ErrorAccess />
    } else if (_detail != null) {
    	return accessRole('read') ? <Detail uuid={_uuid} /> : <ErrorAccess />
    } else if (_listPegawai != null) {
    	return accessRole('read') ? <IndexPegawai /> : <ErrorAccess />
    } else if (_detailPegawai != null) {
    	return accessRole('read') ? <ListPegawai uuid={_uuid} /> : <ErrorAccess />
    } else if (_update != null) {
    	return accessRole('update') ? <Update uuid={_uuid} /> : <ErrorAccess />
    } else if (_list != null) {
    	return accessRole('read') ? <List uuid={_uuid} /> : <ErrorAccess />
    } else if (_delete != null) {
    	return null
    } else if (_approve != null) {
    	return accessRole('approve') ? <Approve uuid={_uuid} /> : <ErrorAccess />
    } else if (_print != null) {
    	return null
    } else if (_revoke != null) {
        return accessRole('approve') ? <Revoke uuid={_uuid} /> : <ErrorAccess />
    } else if (_approveBawahan != null) {
        return accessRole('read') ? <ApproveBawahan uuid={_uuid} /> : <ErrorAccess />
    } else if (_listBawahan != null) {
        return accessRole('read') ? <ListBawahan /> : <ErrorAccess />
    } else if (_saldo != null) {
        return accessRole('read') ? <Saldo uuid={_uuid} /> : <ErrorAccess />
    }

    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    } else {
        return accessRole('read') ? <ListPegawai uuid={_uuid} /> : <ErrorAccess />
    }


}

export default RouteView